/* ============================================================
   slaBadgeView — TASK-255: pure stage-word derivation for the
   shared SlaBadge (TASK-243). The Delivery stage word follows the
   order's G8-D1 delivery-method snapshot: самовывоз/ПВЗ ends in a
   collection handoff, so «скоро срок · доставка» was courier-biased
   on pickup rows (§91). Courier and legacy/no-snapshot rows keep
   «доставка» byte-identical; every other stage word is
   method-independent. Zero runtime imports — plain data in, plain
   string out — so the module runs under `node --test`
   (tests/slaBadgeView.test.ts) as well as in the app bundle.
   No API change. Light theme, Montserrat, iOS-18 minimal per
   DESIGN-SYSTEM.md (labels reuse the existing badge tones).
   ============================================================ */

import type { WebDeliveryMethod } from '../types/product';
import { isPickupDeliveryMethod } from './shippedTrackingView.ts';

/** Courier/legacy stage words (TASK-243 baseline). */
const STAGE_LABELS: Readonly<Record<string, string>> = {
  ProviderResponse: 'приём в работу',
  ProviderResult: 'печать результата',
  CustomerConfirmation: 'подтверждение результата',
  Delivery: 'доставка',
};

/** TASK-255: the delivery stage word for pickup rows — the deadline
 *  is about collecting the order at the point, not dispatch. */
const PICKUP_DELIVERY_LABEL = 'выдача';

/** Stage word for the SlaBadge chip. Delivery is method-aware
 *  (pickup/ПВЗ → «выдача»); absent/legacy snapshot keeps the
 *  courier word, unknown stages pass through as before. */
export function slaStageLabel(
  stage: string,
  deliveryMethod?: WebDeliveryMethod | number | null,
): string {
  if (stage === 'Delivery' && isPickupDeliveryMethod(deliveryMethod)) {
    return PICKUP_DELIVERY_LABEL;
  }
  return STAGE_LABELS[stage] ?? stage;
}
